<div class="pr-panel" [ngClass]="clazz">
  <ng-content></ng-content>
</div>
@if (load) {
  <pr-loader></pr-loader>
}
